import { useCallback, useLayoutEffect, useRef, useState } from 'react'

/** Uma execução por vez; a trava é ref porque o state só chega no render seguinte e toque repetido duplicava pedido. */
export function useAcaoUnica<A extends unknown[], R>(
  acao: (...args: A) => Promise<R>,
): [(...args: A) => Promise<R | undefined>, boolean] {
  const acaoAtual = useRef(acao)
  const travada = useRef(false)
  const [emAndamento, setEmAndamento] = useState(false)

  // Executa sempre a função do último render: a do primeiro teria o estado da tela daquela hora.
  useLayoutEffect(() => {
    acaoAtual.current = acao
  })

  const executar = useCallback(async (...args: A): Promise<R | undefined> => {
    if (travada.current) return undefined
    travada.current = true
    setEmAndamento(true)
    try {
      return await acaoAtual.current(...args)
    } finally {
      travada.current = false
      setEmAndamento(false)
    }
  }, [])

  return [executar, emAndamento]
}
